export enum ActionTypes {
  LOAD_ALARMS_REQUEST = 'LOAD_ALARMS_REQUEST',
  LOAD_ALARMS_SUCCEEDED = 'LOAD_ALARMS_SUCCEEDED',
  LOAD_ALARMS_FAILED = 'LOAD_ALARMS_FAILED',
}
